// import Blank from "./Blank";
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  messagesApi,
  useGetMessagesQuery,
} from '../../../features/messages/messagesApi';
import Error from '../../ui/Error';
import Loader from '../../ui/Loader';
import ChatHead from './ChatHead';
import Messages from './Messages';
import Message from './Message';
import Options from './Options';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useState } from 'react';
import { useEffect } from 'react';

export default function ChatBody() {
  const { id } = useParams();
  const { user } = useSelector((state) => state.auth) || {};

  const { email: userEmail } = user || {};
  const { data, isLoading, isError, error } = useGetMessagesQuery({
    id,
    userEmail,
  });
  const { data: messages, totalCount } = data || {};
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const dispatch = useDispatch();

  // fetch
  const fetchMore = () => {
    setPage((prevPage) => prevPage + 1);
  };

  useEffect(() => {
    if (page > 1) {
      dispatch(
        messagesApi.endpoints.getMoreMessages.initiate({ id, page, userEmail })
      );
    }
  }, [page, id, dispatch, userEmail]);

  useEffect(() => {
    if (totalCount > 0) {
      const more =
        Math.ceil(
          totalCount / Number(process.env.REACT_APP_MESSAGES_PER_PAGE)
        ) > page;
      setHasMore(more);
    }
  }, [totalCount, page]);
  // decide what to render
  let content = null;

  if (isLoading) {
    content = <Loader />;
  } else if (!isLoading && isError) {
    content = (
      <div>
        <Error message={error?.data} />
      </div>
    );
  } else if (!isLoading && !isError && messages?.length === 0) {
    content = <div>No messages found!</div>;
  } else if (!isLoading && !isError && messages?.length > 0) {
    // Messages with inifinite scroll
    const MessagesContent = (
      <InfiniteScroll
        dataLength={messages.length}
        style={{ display: 'flex', flexDirection: 'column-reverse' }}
        next={fetchMore}
        hasMore={hasMore}
        loader={<Loader />}
        inverse={true}
        scrollableTarget="scrollableDiv"
      >
        {messages
          .slice()
          .sort((a, b) => b.timestamp - a.timestamp)
          .map((message) => {
            const { message: lastMessage, id, sender } = message || {};

            const justify = sender.email !== userEmail ? 'start' : 'end';

            return <Message key={id} justify={justify} message={lastMessage} />;
          })}
      </InfiniteScroll>
    );

    content = (
      <>
        <ChatHead message={messages[0]} />
        <Messages>{MessagesContent}</Messages>
        <Options info={messages[0]} />
      </>
    );
  }

  return (
    <div className="w-full lg:col-span-2 lg:block">
      <div className="w-full grid conversation-row-grid">{content}</div>
    </div>
  );
}
